import { FieldData } from "protos/farm/farm";
import { PointSelection } from "./PointSelection";
import { Section } from "portal/components/map/navigation/Section";
import { t } from "i18next";
import React, { FC } from "react";

interface FieldDataProps {
  fieldData: FieldData;
}

export const FieldSelection: FC<FieldDataProps> = ({ fieldData }) => {
  return (
    <Section
      startCollapsed
      isSubsection
      header={t("views.farms.selectionPanel.plantingHeading")}
    >
      <PointSelection pointData={fieldData.plantingHeading?.abLine?.a} />
      <PointSelection pointData={fieldData.plantingHeading?.abLine?.b} />
    </Section>
  );
};
